import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cf951b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-auto rsm:tw-h-full tw-bg-white tw-relative tw-flex tw-flex-col" }
const _hoisted_2 = { class: "tw-relative tw-z-10 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-8 rllg:tw-gap-16 tw-py-10 rllg:tw-py-20 tw-box-border tw-px-6" }
const _hoisted_3 = { class: "tw-w-full tw-items-start tw-flex tw-flex-col rllg:tw-items-center tw-justify-center tw-gap-6 rllg:tw-gap-10" }
const _hoisted_4 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start rllg:tw-items-center tw-justify-center tw-gap-2 rllg:tw-gap-4" }
const _hoisted_5 = { class: "tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 rsm:!tw-flex-row rllg:tw-gap-10" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-[.4rem]" }
const _hoisted_7 = { class: "tw-flex tw-flex-col tw-gap-[.4rem]" }
const _hoisted_8 = { class: "tw-w-full tw-flex tw-items-center tw-justify-center" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import { RolesEnum } from "@/core/enums/RolesEnum";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import { computed } from "vue";

import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import OnboardingWave from "@/core/components/icons/OnboardingWave.vue";
import IknowaLogoBlack from "@/core/components/icons/IknowaLogoBlack.vue";
import OnboardingTradesIcon from "@/core/components/icons/OnboardingTradesIcon.vue";
import OnboardingPropertyIcon from "@/core/components/icons/OnboardingPropertyIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingPage',
  setup(__props) {

const router = useRouter();
const store = useStore();
const userName = store.getters[`${USER_STORE}/user`]?.firstName;

const selectedRole = ref(0);
const loading = ref(false);
// const isAppIknowa = computed(() => {
//   return window.location.hostname.startsWith("app.iknowa");
// });
const selectRole = (role: number) => {
  if (selectedRole.value === role) {
    selectedRole.value = 0; // Deselect if the same card is clicked again
  } else {
    selectedRole.value = role;
  }
};

const returnToSpecialisms = async () => {
  try {
    loading.value = true;
    await store.dispatch(`${USER_STORE}/selectRole`, {
      userId: store.getters[`${USER_STORE}/user`]?.id,
      roleId: selectedRole.value,
      email: store.getters[`${USER_STORE}/user`]?.email,
    });
    if (selectedRole.value == 2) {
      router.push("/owner-onboarding");
    } else {
      router.push("/specilalisms");
    }
  } catch (error) {
    console.log("error:", error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(OnboardingWave, { class: "wave-svg tw-fixed tw-top-0 tw-left-0 tw-object-cover tw-h-auto tw-w-full" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(IknowaLogoBlack, { class: "llg:!tw-w-[133px] llg:!tw-h-[24px]" }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Text, {
            variant: "h4",
            class: "tw-text-start rllg:!tw-text-center rllg:!tw-text-[32px]"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Welcome, " + _toDisplayString(_unref(userName)) + " 👋", 1)
            ]),
            _: 1
          }),
          _createVNode(Text, {
            variant: "h6",
            textWeight: "500",
            class: "tw-hidden rllg:!tw-flex"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Let’s get you started on iknowa. Select the "),
              _createVNode(Text, { variant: "h6" }, {
                default: _withCtx(() => [
                  _createTextVNode(" account type,")
                ]),
                _: 1
              }),
              _createTextVNode(" that best describes you.")
            ]),
            _: 1
          }),
          _createVNode(Text, {
            variant: "p",
            textWeight: "500",
            class: "tw-mt-[-.3rem] rllg:tw-hidden",
            textColor: "rgba(12, 15, 74, 0.5)",
            textAlign: "start"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Let’s get you started on Iknowa. ")
            ]),
            _: 1
          }),
          _createVNode(Text, {
            class: "rllg:tw-hidden",
            variant: "p",
            textColor: "rgba(12, 15, 74, 0.5)",
            textAlign: "start",
            textWeight: "500"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Please select the "),
              _createVNode(Text, { variant: "p" }, {
                default: _withCtx(() => [
                  _createTextVNode("account type")
                ]),
                _: 1
              }),
              _createTextVNode(" that best describes you. ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectRole(_unref(RolesEnum).PROJECT_OWNER))),
          class: _normalizeClass([{
            'tw-border-[#FFA500] tw-border-solid tw-border-[1px]':
              selectedRole.value === _unref(RolesEnum).PROJECT_OWNER,
          }, "onboarding-card tw-w-full tw-min-w-[unset] tw-max-h-[236px] tw-min-h-[236px] rllg:!tw-w-[396px] rllg:!tw-min-w-[396px] rllg:!tw-max-h-[400px] rllg:!tw-min-h-[400px] tw-rounded-[18px] tw-bg-transparent tw-py-8 tw-px-6 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-6 tw-cursor-pointer"])
        }, [
          _createVNode(OnboardingPropertyIcon),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Text, {
              variant: "h6",
              class: "rllg:!tw-text-[20px]",
              textAlign: "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Join To Manage Your Property ")
              ]),
              _: 1
            }),
            _createVNode(Text, {
              variant: "span",
              textWeight: "500",
              class: "rllg:!tw-text-[14px]",
              textColor: "rgba(12, 15, 74, 0.5)",
              lineHeight: "18px"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Get Your Free ‘Know Your Property’ card for insights and start retrofit projects with ease. ")
              ]),
              _: 1
            })
          ])
        ], 2),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectRole(_unref(RolesEnum).TRADESPERSON))),
          class: _normalizeClass([{
            'tw-border-[#FFA500] tw-border-solid tw-border-[1px]':
              selectedRole.value === _unref(RolesEnum).TRADESPERSON,
          }, "onboarding-card tw-w-full tw-min-w-[unset] tw-max-h-[236px] tw-min-h-[236px] rllg:!tw-w-[396px] rllg:!tw-min-w-[396px] rllg:!tw-max-h-[400px] rllg:!tw-min-h-[400px] tw-rounded-[18px] tw-bg-transparent tw-py-8 tw-px-6 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-6 tw-cursor-pointer"])
        }, [
          _createVNode(OnboardingTradesIcon),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Text, {
              variant: "h6",
              class: "rllg:!tw-text-[20px]",
              textAlign: "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Join As A Trade Contractor ")
              ]),
              _: 1
            }),
            _createVNode(Text, {
              variant: "span",
              textWeight: "500",
              class: "rllg:!tw-text-[14px]",
              textColor: "rgba(12, 15, 74, 0.5)",
              lineHeight: "18px"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Create a FREE Personal iknowa HQ & Set-up a Workstation for your Trade Business. ")
              ]),
              _: 1
            })
          ])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(Button, {
          class: "rllg:!tw-max-w-[400px] rllg:!tw-w-[400px]",
          label: "continue",
          disabled: !selectedRole.value,
          loading: loading.value,
          onClick: returnToSpecialisms
        }, null, 8, ["disabled", "loading"])
      ])
    ])
  ]))
}
}

})